// src/hooks/useGoogleAnalytics.ts
import { useEffect } from 'react';

const useGoogleAnalytics = (measurementId: string) => {
  useEffect(() => {
    // Check if the script needs to be added
    if (!window.gtag) {
      // Inject the Google Analytics script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      // Initialize the gtag function
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());

      // Configure the initial page view
      window.gtag('config', measurementId);
    }
  }, [measurementId]); // Ensure it only runs once or when measurementId changes
};

export default useGoogleAnalytics;
